import { Button, ButtonVariant, Intent, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"

const TypeButton = (props: any) : JSX.Element => {
    const sz = 25
    return props.onlyPlainColor || props.onlyPlainColor
        ?
        <></> 
        :
        <Tooltip
            position="top"
            intent={Intent.PRIMARY}
            hoverOpenDelay={1000}
            content={<div className="px-1 smaller letter-spacing-1" >
                {__( props.colorType )}
            </div>}
        > 
            <Button variant={ButtonVariant.MINIMAL} className="mr-3 px-3  w_25" onClick={ props.onChangeType }>
                <img src={ `/assets/img/scalars/${ props.colorType }.svg` } alt="" style={{ width: sz, minWidth: sz, height: sz }} />
            </Button>
        </Tooltip>
}

export default TypeButton